import type { FaireProductEntity } from "../../entity_types/product";

export const p_ut7ncasez6: FaireProductEntity = {
  token: "p_ut7ncasez6",
  type: "product",
  name: "MULTI COLOR PATTERN DESIGN EVIL EYE TOTE BAG, LVBA 001",
  brandToken: "b_gk6kg6d4dw",
  brandName: "JOIA ACCESSORIES",
  imageUrl:
    "https://cdn.faire.com/fastly/bc9d8ef44748d72a3621788c8464630d59b945f9f31ea9658f7f8c833f4d734b.jpeg",
  galleryImageUrls: [],
  priceDollars: 12.12,
  description:
    'MULTI COLOR PATTERN DESIGN EVIL EYE TOTE BAG APPROX 16.5 x 5.5 x 18.5"',
  tags: [],
  msrpDollars: 24.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:24.772Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
